
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Waypoint } from 'react-waypoint'
import { query } from './BreakPoint'

class ResponsiveWaypoint extends PureComponent {
  render () {
  // If we don't have a breakpoint or the query isn't relevant.
    if (!this.props.breakPoint || !query[this.props.breakPoint]()) {
      return (
        <div>
          {this.props.children}
        </div>
      )
    }

    // Otherwise send back our content wrapped in a Waypoint
    return (
      <Waypoint
        onEnter={(e) => e.previousPosition === 'below' && this.props.onEnter()}
        onLeave={(e) => e.currentPosition === 'below' && this.props.onLeave()}>
        <div>
          {this.props.children}
          <Waypoint
            onEnter={(e) => e.previousPosition === 'below' && this.props.onLeave()}
            onLeave={(e) => e.currentPosition === 'below' && this.props.onEnter()} />
        </div>
      </Waypoint>
    )
  }
}

ResponsiveWaypoint.propTypes = {
  breakPoint: PropTypes.string.isRequired,
  onEnter: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired
}

export default ResponsiveWaypoint
